// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAssessmentSupportDocumentApi,
  IAssessmentSupportDocumentApiRequest,
  IAssessmentSupportDocumentApiGetListAttrs,
  IAssessmentSupportDocumentApiListResponse,
  IAssessmentSupportDocumentApiDownloadDocumentAttrs,
  IAssessmentSupportDocumentApiDownloadDocumentResponse,
} from 'interfaces/back-office/assessment/support-document/support-document-api.interface'

// Constant
import { ApiConstant } from 'constant'
import { ASSESSMENT_SUPPORT_DOCUMENT_LIST } from 'constant/assessment/assessment-support-document.constant'

// Utils
import { axios_renderUrl } from 'utils'
import { commonUtils_delay } from 'utils/common/common.utils'

export class AssessmentSupportDocumentApi
  extends BaseApi<IAssessmentSupportDocumentApi>
  implements IAssessmentSupportDocumentApiRequest
{
  readonly url = ApiConstant.ASSESSMENT_SUPPORT_DOCUMENT_URL
  private assessmentSupportDocumentUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get assessment support document list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentSupportDocumentApiGetListAttrs} payload
   *
   * @return {Promise<IAssessmentSupportDocumentApiListResponse>} Promise<IAssessmentSupportDocumentApiListResponse>
   */
  async assessmentSupportDocument_getList(
    payload: IAssessmentSupportDocumentApiGetListAttrs,
  ): Promise<IAssessmentSupportDocumentApiListResponse> {
    try {
      // const response = await this.POST(`${this.assessmentSupportDocumentUrl}/list`, payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ASSESSMENT_SUPPORT_DOCUMENT_LIST)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Download assessment support document, document
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentSupportDocumentApiDownloadDocumentAttrs} payload
   *
   * @return {Promise<IAssessmentSupportDocumentApiDownloadDocumentResponse>} Promise<IAssessmentSupportDocumentApiDownloadDocumentResponse>
   */
  async assessmentSupportDocument_downloadDocument(
    payload: IAssessmentSupportDocumentApiDownloadDocumentAttrs,
  ): Promise<IAssessmentSupportDocumentApiDownloadDocumentResponse> {
    try {
      // const response = await this.POST(`${this.assessmentSupportDocumentUrl}/download/${payload.params.blobId}`, {}, { ...payload.requestConfig, responseType: 'blob' })

      await commonUtils_delay(300)

      return Promise.resolve(null) as any
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
